import React from 'react';

/**
 * MetricTile - MILSIM Component
 *
 * Stat display with value, unit, trend, and label
 * Used for member counts, operations stats, etc.
 */
export const MetricTile = ({
  value,
  label,
  unit,
  trend,
  trendValue,
  icon,
  variant = 'default',
  className = '',
  children,
  ...props
}) => {
  const baseClass = 'tp-metric';
  const variantClass = `tp-metric--${variant}`;
  const trendClass = trend ? `tp-metric--trend-${trend}` : '';

  return (
    <div
      className={`${baseClass} ${variantClass} ${trendClass} ${className}`.trim()}
      {...props}
    >
      {icon && (
        <div className="tp-metric__icon" aria-hidden="true">
          {icon}
        </div>
      )}

      <div className="tp-metric__content">
        <div className="tp-metric__value-wrapper">
          <span className="tp-metric__value">{value}</span>
          {unit && <span className="tp-metric__unit">{unit}</span>}
        </div>

        {label && (
          <div className="tp-metric__label">{label}</div>
        )}

        {trend && trendValue && (
          <div className="tp-metric__trend">
            <span className="tp-metric__trend-indicator">
              {trend === 'up' ? '▲' : trend === 'down' ? '▼' : '●'}
            </span>
            <span className="tp-metric__trend-value">{trendValue}</span>
          </div>
        )}
      </div>

      {children}
    </div>
  );
};

export default MetricTile;
